import React from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

const searchWidthClassBySize = {
    96: 'w-96',
    110: 'w-110',
    120: 'w-120',
    '28rem': 'w-[28rem]',
    144: 'w-144',
    160: 'w-160',
    176: 'w-176',
};

export default function SearchBox({ searchRef, placeholder, width, submitFn }) {
    const searchWidthClass = searchWidthClassBySize[width] || 'w-110';

    return (
        <form
            className={`shrink-0 ${searchWidthClass}`}
            onSubmit={(e) => {
                e.preventDefault();
                submitFn();
            }}
        >
            <div>
                <div className='relative mt-1 rounded-md shadow-sm'>
                    <input
                        ref={searchRef}
                        type='text'
                        name='account-number'
                        id='account-number'
                        className='block w-full rounded-md border-gray-300 pr-10 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                        placeholder={placeholder}
                    />
                    <div className='pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3'>
                        <MagnifyingGlassIcon className='h-5 w-5 text-gray-400' aria-hidden='true' />
                    </div>
                </div>
            </div>
        </form>
    );
}
